import React, { useEffect } from "react";
import { format } from "date-fns";
import { fetchMetrics, MetricsStore } from "./store";

import AmountWithChange from "$components/amount-with-change";

import { SLASH_DATE_TIME_FORMAT, SHORT_DATE_FORMAT } from "$utils/date-helpers";
import { abbrNum } from "$utils/number-helper";

import "./metrics.css";

const MetricsAdmin = () => {
    const metrics = MetricsStore.useState((s) => s);

    useEffect(() => {
        fetchMetrics();
    }, []);

    return (
        <div>
            <h1>Metrics</h1>
            {metrics.map((metric, i) => {
                return (
                    <div key={metric?.etlRun || i} className="dashboard-cards admin-cards">
                        <div className="card -header">
                            {metric?.etlRun ? (
                                <>
                                    <h3 title={format(new Date(metric.etlRun), SLASH_DATE_TIME_FORMAT)}>{format(new Date(metric.etlRun), SHORT_DATE_FORMAT)}</h3>
                                </>
                            ) : (
                                <h3>No Date</h3>
                            )}
                        </div>

                        <div className="card">
                            <h5 className="txt -center">Client Group Count</h5>
                            <AmountWithChange value={abbrNum(metric.clientGroupCount)} changeValue={metric?.clientGroupCountChangeAmount} changePercent={metric?.clientGroupCountChange} changeText="Previous Change" />
                        </div>

                        <div className="card">
                            <h5 className="txt -center">Client Count</h5>
                            <AmountWithChange value={abbrNum(metric.clientCount)} changeValue={metric?.clientCountChangeAmount} changePercent={metric?.clientCountChange} changeText="Previous Change" />
                        </div>

                        <div className="card">
                            <h5 className="txt -center">Potential Poject Count</h5>
                            <AmountWithChange
                                value={abbrNum(metric.potentialProjectCount)}
                                changeValue={metric?.potentialProjectCountChangeAmount}
                                changePercent={metric?.potentialProjectCountChange}
                                changeText="Previous Change"
                            />
                        </div>

                        <div className="card">
                            <h5 className="txt -center">Existing Project Count</h5>
                            <AmountWithChange
                                value={abbrNum(metric.existingProjectCount)}
                                changeValue={metric?.existingProjectCountChangeAmount}
                                changePercent={metric?.existingProjectCountChange}
                                changeText="Previous Change"
                            />
                        </div>

                        <div className="card">
                            <h5 className="txt -center">Team Member Count</h5>
                            <AmountWithChange value={abbrNum(metric.teamMemberCount)} changeValue={metric?.teamMemberCountChangeAmount} changePercent={metric?.teamMemberCountChange} changeText="Previous Change" />
                        </div>

                        <div className="card">
                            <h5 className="txt -center">Office Count</h5>
                            <AmountWithChange value={abbrNum(metric.officeCount)} changeValue={metric?.officeCountChangeAmount} changePercent={metric?.officeCountChange} changeText="Previous Change" />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default MetricsAdmin;
